import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { Button } from 'lib/ui'
import { fetchCart } from 'lib/core/data/quote/cart'
import { useAddPromotionToCart } from 'hooks/useAddPromotionToCart'
interface Props {
  sku: string
  qty: number
  isPromotion?: boolean
  shipmentFrequency: number
  quantityPerDay?: number
  onSuccess?: (param: boolean) => void
}

export const AddToCart = ({
  sku,
  qty,
  isPromotion = true,
  quantityPerDay,
  shipmentFrequency,
  onSuccess
}: Props) => {
  const dispatch = useDispatch()
  const { cartId, addSimpleProduct } = useCart()
  const [addingToCart, setAddingToCart] = useState(false)
  const [addedToCart, setAddedToCart] = useState(false)
  const frequencyInDays = shipmentFrequency * 7
  const { addPromotionToCart, data: promotionResponse, loading } = useAddPromotionToCart()

  useEffect(() => {
    const addPromo = async () => {
      await addPromotionToCart(sku)
      if (cartId) {
        dispatch(fetchCart(cartId))
      }
    }

    if (addedToCart && isPromotion) {
      // eslint-disable-next-line
      addPromo()
    }
    // eslint-disable-next-line
  }, [addedToCart, isPromotion, sku])

  useEffect(() => {
    if (addedToCart && promotionResponse && !loading) {
      onSuccess?.(true)
    }
    // eslint-disable-next-line
  }, [promotionResponse, addedToCart, loading])

  function handleAddSimpleToCart () {
    setAddingToCart(true)
    const cartItems = [{
      quantity: qty,
      sku: sku,
      frequency_in_cart: frequencyInDays.toString() ?? null,
      survey_referral: 1,
      uses_by_day: quantityPerDay
    }]

    addSimpleProduct({
      sku,
      cartItems,
      options: {
        callback: {
          onFailure: () => setAddingToCart(false),
          onSuccess: () => {
            setAddingToCart(false)
            setAddedToCart(true)
          }
        }
      }
    })
  }

  return (
    <>
      <Button
        isLoading={addingToCart || loading}
        isDisabled={!cartId}
        onClick={handleAddSimpleToCart}
        type='button'
      >
        Let’s Start Saving Today!
      </Button>
    </>
  )
}
